import React, { useEffect, useState } from 'react';
//*MUI
import { Box, Modal } from '@mui/material';
//*files
import cssClasses from "./AVSummaryModal.module.css"
import Button from '../../../../Subcomponents/Button';
import Close from '../../../../Components/Icons/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function AVSummaryModal({ open, handleClose, allotment, updateFunction, btnName, sdrPercentage, legalCharges, registrationCharges }) {
  const updatedUnitCost = allotment?.new_unit_cost ? allotment?.new_unit_cost : allotment?.old_unit_cost;
  const [sdr, setSdr] = useState(updatedUnitCost?.sdr);

  useEffect(() => {
    getSDR();
  }, [allotment])

  function getSDR() {
    if (btnName === "Update SDR") {
      let sdrOnePercentLess = ((Math.ceil((Math.round((Number(updatedUnitCost?.bsp) * (sdrPercentage)) / 100)) / 100) * 100) +
        (Number(updatedUnitCost?.bsp) > 3000000
          ? (Math.ceil(Number(registrationCharges / 100) * 100))
          : (Math.ceil(Number(updatedUnitCost?.bsp / 100) / 100) * 100)) +
        legalCharges);
      setSdr(sdrOnePercentLess.toFixed());
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Summary</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
              <div style={{ width: "100%", height: "100%", color: "#515A6B", fontWeight: "600", fontSize: "16px", lineHeight: "26px" }}>
                <div className={cssClasses.ThirdDivRow}>
                  <div>AV Value</div>
                  <div>₹{numberWithCommas(allotment?.old_unit_cost?.bsp)}</div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <div>Changed AV Value</div>
                  <div>{allotment?.is_changeable_value ? (<span>₹{numberWithCommas(updatedUnitCost?.bsp)}</span>) : "NA"}</div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <div>SDR % Approved</div>
                  <div>({sdrPercentage}%) ₹{numberWithCommas(sdr)}</div>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <div>GST %</div>
                  <div>({Math.round(((updatedUnitCost?.gst / updatedUnitCost?.bsp).toFixed(2)) * 100)}%) ₹{numberWithCommas(updatedUnitCost?.gst)}</div>
                  {/* <div>({updatedUnitCost?.bsp < 4500000 ? 1 : 5}%) ₹{numberWithCommas(updatedUnitCost?.gst)}</div> */}
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    color: '#344054',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Cancel'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  //   disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={btnName}
                  clicked={() => updateFunction(allotment)}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default AVSummaryModal;


function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
